/* eslint-disable */

import requestAPI from "./requestAPI";

export type S3UploadProps =
  | { category: "avatar"; fileUri: File[]; userId: string }
  | { category: "property"; fileUri: File[]; propertyId: string }
  | { category: "review"; fileUri: File[]; reviewId: string }
  | {
      category: "assets";
      fileUri: File[];
      assetsCategory: string;
    };

export type FileWithKeys = { file: File; key: string };

const getPresignedURl = async (requestBody: any) => {
  try {
    const { url, key } = await requestAPI({
      method: "post",
      url: "/common/s3-signed-url",
      data: requestBody,
    });
    return { url, key };
  } catch (error) {
    console.error("Error fetching pre-signed URL:", error);
    throw error;
  }
};
//props
export const uploadFilesToS3OnlyKeys = async (props: S3UploadProps) => {
  const _files = Array.from(props.fileUri);
  if (_files.length === 0) return;

  try {
    const uploadMultipleImagesPromise = [] as Promise<any>[];
    const keys = [] as string[];
    for (let i = 0; i < _files.length; i++) {
      const file = _files[i] as File;
      const requestBody: Record<string, string> = {
        fileType: file?.type,
        category: props.category,
      };
      switch (props.category) {
        case "assets":
          requestBody.assetsCategory = props.assetsCategory;
          break;
        case "avatar":
          requestBody.userId = props.userId;
          break;
        case "review":
          requestBody.reviewId = props.reviewId;
          break;
        default:
          return null;
      }
      const uploadPromise = new Promise(async (resolve, reject) => {
        try {
          const { url, key } = await getPresignedURl(requestBody);
          keys.push(key);

          const uploadResponse = await fetch(url, {
            method: "PUT",
            body: file,
          });

          if (!uploadResponse.ok) {
            throw new Error(`Failed to upload file ${file.name} to S3`);
          }

          resolve(`File ${file.name} uploaded successfully`);
        } catch (error) {
          console.error("Error uploading file:", error);
          reject(error);
        }
      });
      uploadMultipleImagesPromise.push(uploadPromise);
    }

    await Promise.all(uploadMultipleImagesPromise);
    return keys;
  } catch (error) {
    console.error("Error uploading files:", error);
    throw error;
  }
};

// export const uploadFilesToS3 = async (filesArr: File[]) => {
//   const _files = Array.from(filesArr);
//   if (_files.length === 0) return;

//   try {
//     const uploadMultipleImagesPromise = [] as Promise<any>[];
//     const uploadedFileWithKeys = [] as FileWithKeys[];

//     for (let i = 0; i < _files.length; i++) {
//       const file = _files[i] as File;
//       const uploadPromise = new Promise(async (resolve, reject) => {
//         try {
//           const { url, key } = await getPresignedURl(re);
//           uploadedFileWithKeys.push({ key, file });

//           const uploadResponse = await fetch(url, {
//             method: "PUT",
//             body: file,
//           });

//           if (!uploadResponse.ok) {
//             throw new Error(`Failed to upload file ${file.name} to S3`);
//           }

//           resolve(`File ${file.name} uploaded successfully`);
//         } catch (error) {
//           console.error("Error uploading file:", error);
//           reject(error);
//         }
//       });

//       uploadMultipleImagesPromise.push(uploadPromise);
//     }

//     await Promise.all(uploadMultipleImagesPromise);
//     return uploadedFileWithKeys;
//   } catch (error) {
//     console.error("Error uploading files:", error);
//     throw error;
//   }
// };

export const getFileURL = (fileWithKeys: FileWithKeys[], file: File) => {
  const uploadedFile = fileWithKeys.find(
    (f) => f?.file?.name === file?.name && f?.file?.type === file?.type
  );

  if (uploadedFile) {
    return uploadedFile?.key;
  }

  return "";
};
